/**
 * Offers Carousel
 *
 * - 1 carte : affichage centré sans Swiper
 * - 2 cartes ou plus : initialisation de Swiper
 *
 * @package Altens
 */

export default function initOffersCarousel(Swiper, Navigation) {
    const offerSliders = document.querySelectorAll(".offers-section__carousel");

    if (!offerSliders.length) return;

    offerSliders.forEach((slider) => {
        // Une seule carte : aucun Swiper à initialiser.
        if (!slider.classList.contains("swiper")) {
            return;
        }

        const wrapper = slider.querySelector(".swiper-wrapper");

        if (!wrapper) {
            return;
        }

        const slides = wrapper.querySelectorAll(".swiper-slide");

        // Sécurité : Swiper nécessite plusieurs cartes ici.
        if (slides.length <= 1) {
            return;
        }

        const nextButton = slider.querySelector(".offers-section__arrow--next");

        const prevButton = slider.querySelector(".offers-section__arrow--prev");

        new Swiper(slider, {
            modules: [Navigation],

            slidesPerView: 1.15,
            spaceBetween: 16,

            watchOverflow: true,
            grabCursor: true,

            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },

            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    allowTouchMove: false,
                },
            },
        });
    });
}
